import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useClickAway from 'react-use/lib/useClickAway';

const SimpleModal = ({
  isOpen,
  onClose,
  children,
  customClass
}) => {
  const ref = useRef(null);
  useClickAway(ref, onClose);
  const showingClass = isOpen ? 'display-block' : 'display-none';
  return (
    <div className={`modal-wrapper ${showingClass}`}>
      <div ref={ref} className={`modal-main ${customClass}`}>
        {children}
      </div>
    </div>
  );
};

SimpleModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
  ]).isRequired
};

export default SimpleModal;
